/**
 * /comms — Communication Center layout route (Agent U1).
 *
 * FLAG GATE (byte-identical OFF): the whole area is behind env.VITE_COMM_CENTER.
 * On an OFF build the nav never links here (Wave-2), and this beforeLoad
 * redirects any direct hit to Home — so the area is fully inert when disabled.
 *
 * The lazy component (comms.lazy.tsx) renders the shared section tabs + <Outlet/>
 * for the child routes (inbox, thread, and the sibling areas owned by U2–U4).
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

import { env } from '../../env';

export const Route = createFileRoute('/_authenticated/comms')({
  beforeLoad: () => {
    if (!env.VITE_COMM_CENTER) {
      throw redirect({ to: '/' });
    }
  },
});
